"use client";

import { useContext } from "react";

import { Button } from "@/components/Button";

import { QREditorContext } from "@/contexts/QREditorContext";

import { QREditorContextProps } from "@/contexts/QREditorContext/types";
import { QRSelectorGridProps } from "./types";

import "./styles.scss";

export const QRSelectorGrid = (props: QRSelectorGridProps) => {
  const { data, onClickQRselect, onHoverChangeQRType } = props;

  const qrEditorContext = useContext<QREditorContextProps<any>>(QREditorContext);

  return (
    <div className="qr-selector-grid">
      {data?.previewSelector?.items?.map((item, i) => (
        <Button
          key={i}
          bold
          chip={item.chip}
          dataQA={item.data_qa}
          icon={
            <div className="button__icon">
              <div>
                <img
                  src={`../../svg/icon-qr-${item.id}.svg`}
                  alt={`QR ${item.title} icon`}
                  title={`QR ${item.title} icon`}
                />
              </div>
            </div>
          }
          active={item.id === qrEditorContext?.qrData.type}
          onMouseEnter={() => onHoverChangeQRType(item.id, item.title)}
          onClick={() => onClickQRselect(item.id, item.title)}
          label={item.title}
          description={item.description}
          buttonState={{ "qr type": item.id }}
          className="qr-home-button"
        />
      ))}
    </div>
  );
};
